import { Center, Heading, Text, Box, Link } from '@chakra-ui/react';
import { useState } from 'react';
import RobotIcon from 'src/assets/icons/RobotIcon';
import TickCircleIcon from 'src/assets/icons/TickCircleIcon';
import { Link as RouterLink } from 'react-router-dom';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginLayout from './LoginLayout';

export default function ForgotPassword() {
  const [submittedEmail, setSubmittedEmail] = useState<string>('');

  return (
    <LoginLayout title="Forgot Password">
      <Link asChild>
        <RouterLink to="/login">&larr; Back</RouterLink>
      </Link>
      {submittedEmail ? (
        <Box>
          <Center>
            <TickCircleIcon w="90px" h="90px" />
          </Center>
          <Heading size="h3" textAlign="center" mt="34px">
            Check your inbox
          </Heading>
          <Text textAlign="center" mt="14px" visual="lighter">
            We&apos;ve sent you instructions on how to reset your password to this email adddress:
          </Text>
          <Center bg="podcastShade100" borderRadius="8px" height="48px" width="100%" mt="18px">
            <Text visual="lighter">{submittedEmail}</Text>
          </Center>
          <Text textAlign="center" mt="24px" visual="lighter">
            If you don&apos;t see the message straight away, make sure to check your spam folder, or
            that there aren&apos;t any typos in the email above.
          </Text>
        </Box>
      ) : (
        <>
          <Center>
            <RobotIcon />
          </Center>
          <Heading size="h3" whiteSpace="nowrap" mt="16px" textAlign="center">
            Lost your password?
          </Heading>
          <Text size="p2" mt="8px" textAlign="center">
            Don&apos;t worry! Enter your email below and we&apos;ll send you instructions on how to
            reset it.
          </Text>
          <ForgotPasswordForm mt="30px" onSuccess={email => setSubmittedEmail(email)} />
        </>
      )}
    </LoginLayout>
  );
}
